    
<template>
  <common-page-layout v-if="business">
      <span slot="fixedtopbuttons">
        <back-button @click="$router.push('/admin/home')"/>
        <large-button v-if="business.name" @click="saveBusiness(business)">Save</large-button>
      </span>
         
    <tablink-layout style="margin-top:10px" show="home">    
      <tab-link-button id="home">Home</tab-link-button>          
      <tab-link-button id="about" v-if="business.pwa">About</tab-link-button>            
      <tab-link-button id="status">Status</tab-link-button>
      <tab-link-button id="config" v-if="sysadmin">Config</tab-link-button>
      <tab-link-button id="location">GPS</tab-link-button>            
      <tab-link-button id="image">Image</tab-link-button>            
      <tab-link-button id="theme" v-if="sysadmin">Themes</tab-link-button>      
      <tab-link-button id="linkedbusinesses">Business Links</tab-link-button>        
    </tablink-layout>


    <tab-layout id="linkedbusinesses_tab">
      <p>
          <b><font color="green">Here you can view all linked businesses, you can add or remove links.</font></b> 
      </p> 
      <ul-layout >      
        <li :key="index" v-for="(franchisee,index) in business.franchisees">* {{franchisee.name}}</li>
      </ul-layout>

    </tab-layout>

    <tab-layout id="home_tab">
      <p>
        <label class="w3-text-grey">Main Address</label>
        <textarea class="w3-input w3-border" style="resize:none" v-model="business.address"></textarea>
      </p>
      <p>
        <label class="w3-text-grey">Cellphone</label>
        <input type="tel" class="w3-input w3-border" style="resize:none" v-model="business.phone"/>
      </p>

      <p>
        <label class="w3-text-grey">Phone</label>
        <input type="tel" class="w3-input w3-border" style="resize:none" v-model="business.phone2"/>
      </p>

      <p>
        <label class="w3-text-grey">Contact Email</label>
        <input type="text" class="w3-input w3-border" style="resize:none" v-model="business.email"/>
      </p>

      <p>
        <label class="w3-text-grey">Website</label>
        <input type="text" class="w3-input w3-border" style="resize:none" v-model="business.website"/>
      </p>    

      <p v-if="business.pwa"> 
        <label class="w3-text-grey">Hours</label>
        <input type="text" class="w3-input w3-border" style="resize:none" v-model="business.pwa.openhours"/>
      </p>   

      
      <p v-if="business.pwa">      
            <textarea class="w3-input w3-border" rows="15" style="resize:none" v-model="business.pwa.homeabout"></textarea>
      </p>   
    </tab-layout>

    <tab-layout id="about_tab" v-if="business.pwa">
      <p>      
        <textarea class="w3-input w3-border" rows="2" style="resize:none" v-model="business.pwa.about"></textarea>
      </p>   
      <p>      
        <textarea class="w3-input w3-border" rows="2" style="resize:none" v-model="business.pwa.howto"></textarea>
      </p>
      <p>      
        <textarea class="w3-input w3-border" rows="3" style="resize:none" v-model="business.pwa.instructions"></textarea>
      </p> 
    </tab-layout>


    <tab-layout id="theme_tab">
        <h3>Available Themes</h3>
   
        <p>
          <input type="radio" id="black" :value="{sitetheme:'w3-theme-black.css',pwa:'#000000'}" v-model="business.theme">
          <label style="color:#000000" for="black">black</label>          
        </p>  
        <p>
          <input type="radio" id="bluegrey" :value="{sitetheme:'w3-theme-blue-grey.css',pwa:'#607d8b'}" v-model="business.theme">
          <label style="color:#607d8b" for="bluegrey">blue-grey</label>          
        </p>
        <p>
          <input type="radio" id="blue" :value="{sitetheme:'w3-theme-blue.css',pwa:'#2196f3'}" v-model="business.theme">
          <label style="color:#2196f3" for="blue">blue</label>          
        </p>
        <p>
          <input type="radio" id="indigo" :value="{sitetheme:'w3-theme-indigo.css',pwa:'#3f51b5'}" v-model="business.theme">
          <label style="color:#3f51b5" for="indigo">indigo</label>          
        </p> 
        <p>
          <input type="radio" id="lightblue" :value="{sitetheme:'w3-theme-light-blue.css',pwa:'#87ceeb'}" v-model="business.theme">
          <label style="color:#87ceeb" for="lightblue">light-blue</label>          
        </p>
        <p>
          <input type="radio" id="cyan" :value="{sitetheme:'w3-theme-cyan.css',pwa:'#00bcd4'}" v-model="business.theme">
          <label style="color:#00bcd4" for="cyan">cyan</label>          
        </p>
        <p>
          <input type="radio" id="teal" :value="{sitetheme:'w3-theme-teal.css',pwa:'#009688'}" v-model="business.theme">
          <label style="color:#009688" for="teal">teal</label>          
        </p>
        <p>
          <input type="radio" id="brown" :value="{sitetheme:'w3-theme-brown.css',pwa:'#795548'}" v-model="business.theme">
          <label style="color:#795548" for="brown">brown</label>          
        </p>
       
        <p>
          <input type="radio" id="darkgrey" :value="{sitetheme:'w3-theme-dark-grey.css',pwa:'#616161'}" v-model="business.theme">
          <label style="color:#616161" for="darkgrey">dark-grey</label>          
        </p>
        <p>
          <input type="radio" id="grey" :value="{sitetheme:'w3-theme-grey.css',pwa:'#9e9e9e'}" v-model="business.theme">
          <label style="color:#9e9e9e" for="grey">grey</label>          
        </p> 
        <p>
          <input type="radio" id="red" :value="{sitetheme:'w3-theme-red.css',pwa:'#f44336'}" v-model="business.theme">
          <label style="color:#f44336" for="red">red</label>          
        </p>
        <p>
          <input type="radio" id="deeporange" :value="{sitetheme:'w3-theme-deep-orange.css',pwa:'#ff5722'}" v-model="business.theme">
          <label style="color:#ff5722" for="deeporange">deep-orange</label>          
        </p>

        <p>
          <input type="radio" id="orange" :value="{sitetheme:'w3-theme-orange.css',pwa:'#ff9800'}" v-model="business.theme">
          <label style="color:#ff9800" for="orange">orange</label>          
        </p>
        <p>
          <input type="radio" id="pink" :value="{sitetheme:'w3-theme-pink.css',pwa:'#e91e63'}" v-model="business.theme">
          <label style="color:#e91e63" for="pink">pink</label>          
        </p> 
        <p>
          <input type="radio" id="deeppurple" :value="{sitetheme:'w3-theme-deep-purple.css',pwa:'#673ab7'}" v-model="business.theme">
          <label style="color:#673ab7" for="deeppurple">deep-purple</label>          
        </p>
        <p>
          <input type="radio" id="purple" :value="{sitetheme:'w3-theme-purple.css',pwa:'#9c27b0'}" v-model="business.theme">
          <label style="color:#9c27b0" for="purple">purple</label>          
        </p>  


   
    
        <p>
          <input type="radio" id="green" :value="{sitetheme:'w3-theme-green.css',pwa:'#4caf50'}" v-model="business.theme">
          <label style="color:#4caf50" for="green">green</label>          
        </p>   
        <p>
          <input type="radio" id="lightgreen" :value="{sitetheme:'w3-theme-light-green.css',pwa:'#8bc34a'}" v-model="business.theme">
          <label style="color:#8bc34a" for="lightgreen">light-green</label>          
        </p>
        <p>
          <input type="radio" id="lime" :value="{sitetheme:'w3-theme-lime.css',pwa:'#cddc39'}" v-model="business.theme">
          <label style="color:#cddc39" for="lime">lime</label>          
        </p>
        
        <p>
          <input type="radio" id="amber" :value="{sitetheme:'w3-theme-amber.css',pwa:'#ffc107'}" v-model="business.theme">
          <label style="color:#ffc107" for="amber">amber</label>          
        </p>  
      
        <p>
          <input type="radio" id="yellow" :value="{sitetheme:'w3-theme-yellow.css',pwa:'#ffeb3b'}" v-model="business.theme">
          <label style="color:#ffeb3b" for="yellow">yellow</label>          
        </p>
        <p>
          <input type="radio" id="khaki" :value="{sitetheme:'w3-theme-khaki.css',pwa:'#f0e68c'}" v-model="business.theme">
          <label style="color:#f0e68c" for="khaki">khaki</label>          
        </p>
        <p v-if="business.theme">
          <label for="black">Custom PWA</label><br>
          <input type="input" class="w3-input w3-border" id="custom" v-model="business.theme.pwa">                    
          <label for="black">Custom Site Theme</label><br>
          <input type="input" class="w3-input w3-border w3" id="custom" v-model="business.theme.sitetheme">  
        </p>


    </tab-layout>

    <tab-layout id="status_tab">
        <h3>Ordering Status</h3>  
        <p>
          <b><font color="green">NOTE!! When changing the status you do not need to save as this happens in the background and in the cloud it will automatically change when ready, this allows us to configure your TILES and deals automatically.</font></b> 
        </p>     
        <status-selector :value="business.status" @statusselected="businesscommands({command:'changeBusinessStatus',business,meta:{status:$event.action}})"/>
    </tab-layout>

    <tab-layout id="config_tab">
        <admin-common-config :business="business"/>        
    </tab-layout>


    <tab-layout id="location_tab">        
        <p>
            <label class="w3-text-green">Actual Shop Location</label><br>      
            <font color="green">This sets the location of your home shop/store or business, this location is used to let customers know where your business is, it is also used as the default location for your TILES.</font>
        </p>
        <p>
          <b><font color="red">NOTE!! When changing selection the location will change immediately.</font></b> 
        </p> 
        <p>
          <set-location-button v-if="business" :value="{latitude:business.latitude,longitude:business.longitude}" @input="updateBusinessLocation({foundlocation:$event,id:business.id})"/>
        </p> 

          <!-- <large-button @click="updateBusinessLocation(business.id)">Use current location</large-button>
          <open-gooogle-maps v-if="business.latitude && business.longitude" :latitude="business.latitude" :longitude="business.longitude">Open Map</open-gooogle-maps> -->
        
    </tab-layout>

    <tab-layout id="image_tab">
        <p v-if="business.image" class="w3-container w3-center">
            <img :src="business.image" height="100px" class="w3-image" alt="home image"/>
        </p> 
        <p>
          <b><font color="green">NOTE!! When changing an image you do not need to save as this happens in the background and in the cloud it will automatically refresh when ready.</font></b> 
        </p>       
        <image-editor :config="{id:business.id,location:'web/businesses',maxsize:10}"/> 
    </tab-layout>

    

  </common-page-layout>
</template>


<script>

  import AdminBusinessProjects from "./AdminBusinessProjects"
  import AdminCommonConfig from "./AdminCommonConfig"

  import {
    mapGetters,
    mapActions
  } from "vuex";
  // var mounted=true;
  export default {
    data: function() {
      return {
        metaconfig:{}
      };
    },
    components:{
            'business-projects': AdminBusinessProjects,
            'admin-common-config': AdminCommonConfig
    },
    methods: { 
      saveBusiness(){          
          this.businesscommands({command:'saveBusinessStandardAdmin',business:this.business})
      },  
      ...mapActions(["updateBusinessLocation","businesscommands","enableBusinesssAccount","enableBusinessPositions"])
    },
    computed: {
      ...mapGetters(["business","sysadmin"])
    }
  };
</script>
 
<style>

  textarea {
    width: 100%;
    height: 150px;
    padding: 12px 20px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
    resize: none;
  }
  
  .description {
    padding-bottom: 10px;
    text-align: center;
  }
  
  .groupings {
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminCommon.vue